import { addCard } from "./cardHelper";
import { shuffle } from "../../../utils/array";
import { PLAYER_FRAME, DEFAULT_FRAME, entityRecord } from "../../../data/settings";

const allItems = Object.entries(entityRecord).filter(([key]) => key !== PLAYER_FRAME);

const getKnownItems = (level: number) =>
  allItems.filter(([, stats]) => stats.level === level).map(([key]) => key);

export function addCards(scene: Phaser.Scene, cols: number, level: number) {
  const items = getKnownItems(level);
  let entries = shuffle(items);
  const { length } = entries;
  for (let i = 1; i <= cols; i += 1) {
    for (let j = 0; j < 3; j += 1) {
      const index = i * 3 + j;
      if (index % length === length - 1) entries = shuffle(items);
      const name = entries[index % length] ?? DEFAULT_FRAME;
      addCard(scene, name, i, j);
    }
  }
}
